<div class="bloco-card bloco-acao" (click)="irParaRelatorios()">
  <span class="bloco-icone">
    <mat-icon aria-hidden="true">assessment</mat-icon>
  </span>

  <div class="bloco-textos">
    <h3 class="bloco-title">Relatórios avançados</h3>
    <p class="bloco-desc">Acompanhe todos os indicadores das obras do seu time</p>
  </div>

  <button class="btn-acao" type="button" (click)="irParaRelatorios(); $event.stopPropagation()">
    Explorar
  </button>
</div>